/**
 * Triggers a browser download for a generated Blob.
 *
 * @param fileBlob Blob contents to download.
 * @param filename Download filename.
 * @return void
 */
export function downloadBlob(fileBlob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(fileBlob);
  const anchor = document.createElement("a");

  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.style.display = "none";

  try {
    document.body.appendChild(anchor);
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
  }
}
